// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressesController from "./addresses_controller"
application.register("addresses", AddressesController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import CompanyFormsController from "./company_forms_controller"
application.register("company-forms", CompanyFormsController)

import MapsController from "./maps_controller"
application.register("maps", MapsController)

import MedicalPetShirtsController from "./medical_pet_shirts_controller"
application.register("medical-pet-shirts", MedicalPetShirtsController)

import PasswordsController from "./passwords_controller"
application.register("passwords", PasswordsController)

import ProductsController from "./products_controller"
application.register("products", ProductsController)

import SuiticalController from "./suitical_controller"
application.register("suitical", SuiticalController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
